import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LedgerEventSchema = withDefaults({
  type: 'ledger-event',
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'eventDate',
    },
    {
      kind: 'attribute',
      name: 'eventType',
    },
    {
      kind: 'attribute',
      name: 'itemType',
    },
    {
      kind: 'attribute',
      name: 'itemId',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'postedAt',
    },
    {
      kind: 'attribute',
      name: 'product',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'hasMany',
      name: 'ledgerEntries',
      type: 'ledger-entry',
      options: {
        async: false,
        inverse: 'ledgerEvent',
      },
    },
  ],
});

export default LedgerEventSchema;
